/**
 * Format latitude and longitude in Brazilian/DMS display format.
 */
export function formatLatLon(lat: number, lon: number): string {
  const latDir = lat >= 0 ? 'N' : 'S';
  const lonDir = lon >= 0 ? 'L' : 'O';
  const absLat = Math.abs(lat).toFixed(6);
  const absLon = Math.abs(lon).toFixed(6);
  return `${absLat}° ${latDir}, ${absLon}° ${lonDir}`;
}

/**
 * Format a single coordinate value to 6 decimal places.
 */
export function formatCoordinate(value: number): string {
  return value.toFixed(6);
}

/**
 * Build a Google Maps link for a coordinate pair.
 */
export function buildGoogleMapsUrl(lat: number, lon: number): string {
  return `https://www.google.com/maps?q=${lat},${lon}`;
}

/**
 * Calculate approximate distance in kilometers between two points
 * using the Haversine formula.
 */
export function haversineKm(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number {
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function toRad(deg: number): number {
  return (deg * Math.PI) / 180;
}
